function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState } from 'react';
import { Provider } from '@adobe/react-spectrum';
import { nanoid } from 'nanoid';
import { themeDHDefault } from "../spectrum/utils/index.js";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Wrapper around React Spectrum's theme Provider that provides DH mappings of
 * Spectrum's theme variables to DH's theme variables. Also exposes an optional
 * `isPortal` prop that if provided, adds a unique `data-unique-id` attribute to
 * the Provider. This is needed to force the Provider to render the theme wrapper
 * inside of portals.
 */
export function SpectrumThemeProvider(_ref) {
  var children = _ref.children,
    _ref$isPortal = _ref.isPortal,
    isPortal = _ref$isPortal === void 0 ? false : _ref$isPortal,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? themeDHDefault : _ref$theme,
    colorScheme = _ref.colorScheme,
    zIndex = _ref.zIndex,
    position = _ref.position;
  // a unique ID is used per provider to force it to render the theme wrapper element inside portals
  // based on https://github.com/adobe/react-spectrum/issues/1697#issuecomment-999827266
  // won't be needed if https://github.com/adobe/react-spectrum/pull/2669 is merged
  var _useState = useState(isPortal ? nanoid() : null),
    _useState2 = _slicedToArray(_useState, 1),
    id = _useState2[0];
  return /*#__PURE__*/_jsx(Provider, {
    UNSAFE_className: "spectrum-theme-provider",
    theme: theme,
    colorScheme: colorScheme,
    zIndex: zIndex,
    position: position,
    "data-unique-id": id,
    children: children
  });
}
//# sourceMappingURL=SpectrumThemeProvider.js.map